var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "environments mt15" },
    [
      _c("img", {
        staticClass: "mb10",
        attrs: {
          src: _vm.userCommonImageUrlForSp + "/company_data_sp.png",
          alt: "environments",
          width: "125",
        },
      }),
      _vm._v(" "),
      _c("h3", { staticClass: "fs14 fwB" }, [
        _vm._v("\n    データで見る働く環境\n  "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "fs11 tr mt5" }, [
        _vm._v(
          "\n    " + _vm._s(_vm._f("formatDate")(_vm.updateDate)) + "時点\n  "
        ),
      ]),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }